import { Spin } from "antd";

const Loader = () => {
  return (
    <div
      className="row mx-0 justify-content-center align-items-center"
      style={{ height: "90vh" }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;